<template>
    <v-dialog v-model="dialog" width="900" scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                {{ Object.keys(ticket).length > 0 ? `Reabrir ticket N° ${ticket?.ticket_id}` : 'Cargar ticket' }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="6" sm="3" md="2" class="py-0">
                            <v-autocomplete v-model="data.empresa" label="Empresa" item-text="nombre" item-value="id"
                                :items="familias" :rules="[rules.required]" validate-on-blur autofocus outlined dense
                                @change="setSucursal"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.sucursal" label="Sucursal" item-text="provincia"
                                item-value="id"
                                :items="sucursales.filter(sucursal => sucursal.familia_id == data.empresa)"
                                :rules="[rules.required]" validate-on-blur outlined dense
                                @change="local = null"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.solicitante" label="Solicitante" item-text="nombreBusqueda"
                                item-value="Usuario_id" :items="solicitantes" :rules="[rules.required]" validate-on-blur
                                outlined dense></v-autocomplete>
                        </v-col>
                        <v-col cols="11" sm="3" class="py-0">
                            <v-autocomplete v-model="data.tipo" label="Tipo" item-text="nombre" item-value="tipo_id"
                                :items="tipos_tickets" :rules="[rules.required]" validate-on-blur outlined dense
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="1"
                            style="display: flex; justify-content: center; position: relative; bottom: 16px; right: 10px;">
                            <v-btn icon @click="modalNuevoTipo = true" color="success">
                                <v-icon>fas fa-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.area" label="Area" item-text="nombre" item-value="area_id"
                                :items="areas" :rules="[rules.required]" validate-on-blur outlined dense
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.prioridad" label="Prioridad" item-text="nombre"
                                item-value="prioridad_id" :items="prioridades" outlined dense
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.origen" label="Origen" item-text="nombre"
                                item-value="origen_id" :items="origenes" :rules="[rules.required]" validate-on-blur
                                outlined dense clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="3" class="py-0">
                            <v-text-field v-model.trim="data.teamviewer" label="Team Viewer" :rules="[rules.required]"
                                validate-on-blur outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model.trim="data.asunto" label="Asunto" :rules="[rules.required]"
                                validate-on-blur outlined dense></v-text-field>
                        </v-col>
                        <v-col v-if="Object.keys(ticket).length > 0" cols="6" sm="3" class="py-0">
                            <v-autocomplete v-model="data.usuario_asignado" label="Usuario asignado"
                                item-text="Username" item-value="Usuario_id" :items="usuarios_mesa"
                                :rules="[rules.required]" validate-on-blur outlined dense></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-textarea v-model="data.descripcion" rows="3" :rules="[rules.required]" validate-on-blur
                                outlined dense></v-textarea>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <FileDropzone :files="archivos"
                                :tipos="['.txt', '.png', '.jpg', '.webp', '.doc', '.docx', '.csv', '.xls', '.xlsx', '.pdf']"
                                :multiple="true" :max_size="25" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar :nombre="`${Object.keys(ticket).length > 0 ? 'Reabrir' : 'Cargar'}`"
                    :texto="`${Object.keys(ticket).length > 0 ? `¿Desea reabrir el ticket <strong>${data.asunto}</strong>?` : '¿Desea cargar el ticket?'}`"
                    :loading="load" @action="guardar()"
                    :icono="`${Object.keys(ticket).length > 0 ? 'fas fa-reply' : 'fas fa-save'}`" />
            </v-card-actions>
        </v-card>
        <NuevoTipo v-model="modalNuevoTipo" @actualizarTipo="actualizarNuevoTipo($event)" />
    </v-dialog>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getBase64 } from '../../util/utils'
import BtnConfirmar from '../util/BtnConfirmar.vue';
import FileDropzone from '../util/FileDropzone.vue';
import { convertImageToWebp } from '../../util/imagenes';
import NuevoTipo from './NuevoTipo.vue';

export default {
    data() {
        return {
            load: false,
            local: null,
            archivos: [],
            rules: {
                required: value => !!value || 'Campo requerido'
            },
            modalNuevoTipo: false,
            data: {
                empresa: null,
                sucursal: null,
                solicitante: '',
                teamviewer: '',
                origen: null,
                tipo: null,
                area: null,
                asunto: '',
                descripcion: '',
                solicitante_nombre: '',
                prioridad: null,
                usuario_asignado: null
            }
        }
    },
    async created() {
        this.$store.state.loading = true
        this.$store.state.loading = false

        await this.$store.dispatch('genericos/get_sucursales')
        await this.init_form()

        if (this.familias.length === 1) {
            this.empresa = this.familias[0]
        }
    },
    props: {
        value: Boolean,
        ticket: {
            type: Object,
            default: {}
        },
        prioridades: {
            type: Array,
            default: []
        },

        solicitantes: {
            type: Array,
            default: []
        },

        tipos_tickets: {
            type: Array,
            default: []
        },

        areas: {
            type: Array,
            default: []
        },

        origenes: {
            type: Array,
            default: []
        },

        usuarios_mesa: {
            type: Array,
            default: []
        }
    },
    computed: {
        ...mapState('genericos', ['sucursales']),
        ...mapState(['familias']),
        ...mapGetters(['una_empresa']),
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    components: {
        BtnConfirmar,
        FileDropzone,
        NuevoTipo
    },
    watch: {
        async dialog(val) {
            if (val) {
                await new Promise(resolve => setTimeout(resolve, 1))
                this.init_form()

                if (Object.keys(this.ticket).length > 0) {
                    this.data = {
                        empresa: this.ticket.empresa_id,
                        sucursal: this.ticket.sucursal_id,
                        solicitante: this.ticket.solicitante,
                        area: this.ticket.area_id,
                        tipo: this.ticket.tipo_ticket_id,
                        solicitante_nombre: this.ticket.solicitante_nombre,
                        asunto: `Reabierto N° ${this.ticket.ticket_id} - ${this.ticket.asunto}`,
                        origen: this.ticket.origen_id,
                        prioridad: this.ticket.prioridad_id,
                        teamviewer: this.ticket.teamviewer,
                        usuario_asignado: this.ticket.usuario_asignado
                    }
                }
            } else {
                this.limpiar()
            }
        }
    },
    methods: {
        async guardar() {


            this.$store.state.loading = true
            if (this.$refs.form.validate()) {
                // valido si en algun lado de la descripcion puso adjunto para avisarle por si no adjuntó nada
                const tiene_adjunto = this.data.descripcion.toLowerCase().indexOf('adjunto') >= 0
                const tiene_archivo = this.data.descripcion.toLowerCase().indexOf('archivo') >= 0
                if ((tiene_adjunto || tiene_archivo) && this.archivos.length == 0) {
                    let ups_me_olvide_el_archivo = false
                    await this.$swal.fire({
                        icon: 'warning',
                        html: `Se encontró la palabra <strong>${tiene_archivo ? 'archivo' : ''} ${tiene_adjunto ? 'adjunto' : ''}</strong> en el cuerpo del mensaje
              pero no se seleccionó ningún archivo.<div style="font-size: 20px; margin-top: 12px"><strong>¿Desea cargar el incidente de todas formas?</strong></div>`,
                        confirmButtonText: 'Sí, cargar de todas formas',
                        denyButtonText: 'No, seleccionar archivos',
                        denyButtonColor: '#3085d6',
                        showDenyButton: true,
                        focusDeny: true
                    })
                        .then((res) => {
                            // si pone que no o hace click fuera del modal no hace nada
                            if (!res.isConfirmed) {
                                ups_me_olvide_el_archivo = true
                            }
                        })
                    if (ups_me_olvide_el_archivo) return
                }
                this.load = true

                let archivos = []
                const nombreArchivos = []

                if (this.archivos.length > 0) {
                    for (const archivo of this.archivos) {
                        const archivoConvertido = await convertImageToWebp(archivo);
                        nombreArchivos.push(archivoConvertido.name);
                        const fileBase64 = await getBase64(archivoConvertido);
                        archivos.push(fileBase64);
                    }
                }

                const solicitante = this.solicitantes.find(sol => sol.Usuario_id === this.data.solicitante)
                this.data.solicitante_nombre = `${solicitante.Nombre} ${solicitante.Apellido}`.toUpperCase()

                await this.$store.dispatch('tickets/cargarTicketMesa', this.data)
                    .then(async (res) => {
                        if (res.exito) {

                            if (archivos.length === 0) {
                                this.dialog = false
                                await this.$swal.fire({
                                    icon: res.exito ? 'success' : 'warning',
                                    title: res.message,
                                })
                                this.$emit('actualizarTicket', res.data)
                                this.$emit('actualizar')
                                return
                            }

                            // CARGO LOS ARCHIVOS       
                            await this.$store
                                .dispatch('tickets/cargarArchivos', {
                                    archivos,
                                    nombreArchivos,
                                    ticket_id: res.data.ticket_id,
                                    estado_id: res.data.estado_id,
                                    comentario_id: null
                                })
                                .then(resArchivos => {
                                    if (resArchivos.exito) {
                                        this.dialog = false
                                        if (resArchivos.feedbackFallidos.length > 0) {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                                html: `<strong>${resArchivos.feedbackFallidos}</strong>`,
                                                width: '450px'
                                            })
                                        } else {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: resArchivos.message,
                                            })
                                        }
                                    } else {
                                        this.$store.dispatch('show_snackbar', {
                                            text: resArchivos.message,
                                            color: 'error'
                                        })
                                    }
                                })
                        }
                        this.$emit('actualizar')
                    })
                    .catch(error => {
                        this.$store.state.loading = false
                        this.$store.dispatch('show_snackbar', {
                            text: error.message,
                            color: 'error'
                        })
                    })
                this.load = false
            }
            this.$store.state.loading = false
        },
        async init_form() {
            if (this.familias.length == 1) {
                this.empresa = this.familias[0]
            }
        },

        setSucursal() {
            const sucursal = this.sucursales.filter(
                suc => suc.familia_id === this.data.empresa
            )
            sucursal.length === 1 ? (this.data.sucursal = sucursal[0].id) : null
        },

        actualizarNuevoTipo(nuevoTipo) {
            if (nuevoTipo) {
                this.tipos_tickets.push(nuevoTipo)
                this.data.tipo = nuevoTipo.tipo_id
            }
        },


        limpiar() {
            this.$refs.form.resetValidation()
            this.data = {
                empresa: null,
                sucursal: null,
                solicitante: '',
                teamviewer: '',
                origen: null,
                tipo: null,
                area: null,
                asunto: '',
                descripcion: '',
                solicitante_nombre: '',
                prioridad: null,
                usuario_asignado: null
            }
            this.local = null
            this.archivos = []
        }
    }
}
</script>